module.exports = ".remove-image {\n  color: red; }\n\n.disabled-icon {\n  opacity: 0.5;\n  pointer-events: none;\n  cursor: not-allowed; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/image-or-iframe/image-or-iframe.component.scss
// module id = ./src/app/modules/image-or-iframe/image-or-iframe.component.scss
// module chunks = main